// vendorsVerify.js
import apiClient from "./axios.config";

const vendorsVerify = {
  verify: async (vendorGuid) => {
    console.log(vendorGuid);
    try {
      const response = await apiClient.post(
        `/vendor/email-verification?vendorGuid=${vendorGuid}`
      );

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default vendorsVerify;
